import React, { Component } from 'react';

import { CustomTableBodyRow } from './BodyRow.styles';

class BodyRow extends Component {
  render() {
    const { clickable, onClick, children, hoverable } = this.props;
    return (
      <CustomTableBodyRow clickable={clickable ? 1 : 0} hoverable={hoverable ? 1 : 0} onClick={onClick}>
        {children}
      </CustomTableBodyRow>
    );
  }
}

export default BodyRow;
